import { Machine } from 'xstate';

export default Machine({
  key: 'editProfile',
  initial: 'loading',
  states: {
    loading: {
      on: {
        GET_PROFILE_SUCCESS: 'idle',
        UPDATED: 'updated',
        ERROR: 'error',
      },
    },
    idle: {
      on: {
        PHOTO_SIZE_ERROR: 'photo_size_error',
        PROFILE_UPDATE: 'loading',
      },
    },
    updated: {
      on: {
        CONFIRM: 'idle',
      },
    },
    error: {
      on: {
        CANCEL: 'idle',
        RETRY: 'loading',
      },
    },
    photo_size_error: {
      on: {
        CANCEL: 'idle',
      },
    },
  },
});
